import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/style-component/layouts/adminStyle.js";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { getModuleWithComponent } from "util/common/Common.js";
import SidebarNew from "../components/Sidebar/SidebarNew";
import AdminNavbar from "../components/Navbars/AdminNavbar";
import logo from "assets/img/riotransa.png";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Tooltip from "@mui/material/Tooltip";

const useStyles = makeStyles(styles);
const SIDEBAR_WIDTH = 220;

export default function Admin({ ...rest }) {
    const classes = useStyles();
    const mainPanel = React.createRef();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const location = useLocation();
    const isHome = location.pathname === "/admin/home";

    const [navData, setNavData] = React.useState({
        menu: [],
        subMenu: [],
        subMenuHijo: [],
        modulo: ""
    });

    const loadNavigation = React.useCallback(() => {
        const data = getModuleWithComponent() || {};
        setNavData({
            menu: data.menu || [],
            subMenu: data.subMenu || [],
            subMenuHijo: data.subMenuHijo || [],
            modulo: data.modulo || ""
        });
    }, []);

    React.useEffect(() => {
        loadNavigation();
        const onPermissionsUpdated = () => loadNavigation();
        window.addEventListener("permissions-updated", onPermissionsUpdated);
        return () => window.removeEventListener("permissions-updated", onPermissionsUpdated);
    }, [loadNavigation]);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const { menu, subMenu, subMenuHijo, modulo } = navData;
    const views = [...menu, ...subMenu, ...subMenuHijo];

    const switchRoutes = () => (
        <Switch>
            {views.map((prop, key) => {
                if (prop.layout === "/admin" && prop.path !== "/") {
                    return (
                        <Route
                            path={prop.layout + prop.path}
                            component={prop.component}
                            key={key}
                        />
                    );
                }
                return null;
            })}
            <Redirect from="/admin" to="/admin/home" />
        </Switch>
    );

    return (
        <div className={classes.wrapper}>
            <SidebarNew
                menu={menu}
                submenu={subMenu}
                submenuhijo={subMenuHijo}
                logoText={modulo}
                logo={logo}
                handleDrawerToggle={handleDrawerToggle}
                open={mobileOpen}
                {...rest}
            />

            {/* Botón hamburguesa flotante — solo visible cuando el sidebar está cerrado */}
            {!mobileOpen && (
                <Tooltip title="Abrir menú" placement="right">
                    <IconButton
                        onClick={handleDrawerToggle}
                        size="small"
                        style={{
                            position: "fixed",
                            left: 0,
                            top: 12,
                            zIndex: 1300,
                            backgroundColor: "#1a237e",
                            color: "#fff",
                            width: 18,
                            height: 34,
                            padding: 0,
                            borderRadius: "0 6px 6px 0",
                            opacity: 0.5,
                            transition: "opacity 0.2s",
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.opacity = 1; }}
                        onMouseLeave={(e) => { e.currentTarget.style.opacity = 0.5; }}
                    >
                        <MenuIcon style={{ fontSize: 14 }} />
                    </IconButton>
                </Tooltip>
            )}

            <div
                className={classes.mainPanel}
                ref={mainPanel}
                style={{
                    width: mobileOpen ? `calc(100% - ${SIDEBAR_WIDTH}px)` : "100%",
                    transition: "width 0.3s ease",
                    paddingLeft: mobileOpen ? 0 : 0,
                }}
            >
                {!isHome && (
                    <AdminNavbar routes={views} modulo={modulo} />
                )}
                <div
                    className={classes.map}
                    style={{ height: isHome ? "100%" : undefined }}
                >
                    {switchRoutes()}
                </div>
            </div>
        </div>
    );
}
